import { loadErrorLine } from '../../api/errors';
import { useEvents } from '../../api/event-hooks';
import { eventDates, LOADING } from '../../lib/copy';
import { joinClauses } from '../../lib/format';

/**
 * **The event an event report is about** (`ReportTypeDef.event`): the tracked
 * events on the chosen account, newest first as the Events page lists them.
 * The report's account is the event's, so the list waits for the account.
 */
export function EventChoice({
  accountId,
  value,
  onChange,
}: {
  accountId: string | null;
  value: string;
  onChange: (eventId: string) => void;
}) {
  const events = useEvents({ limit: 100, ...(accountId ? { account_id: accountId } : {}) });
  const rows = (events.data?.pages ?? []).flatMap((page) => page.entries);
  return (
    <label className="field">
      <span className="label">Event</span>
      <span className="report-field-prompt">
        {events.isPending
          ? LOADING
          : events.isError
            ? loadErrorLine(events.error)
            : rows.length === 0
              ? 'No events on this account yet. Add one on the Events page.'
              : 'The event whose attendee list this report reads.'}
      </span>
      <select
        className="control"
        aria-label="Event"
        value={value}
        disabled={rows.length === 0}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Choose an event</option>
        {rows.map((event) => (
          <option key={event.id} value={event.id}>
            {joinClauses([event.display_name, eventDates(event.starts_on, event.ends_on)])}
          </option>
        ))}
      </select>
    </label>
  );
}
